import { contactItem } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mx-auto mb-5">
            <i className="ri-mail-send-line text-3xl md:text-4xl"></i>
          </div>
          <h2 className="section-title">联系我们</h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
            {contactItem.desc}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <div className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-700">
              <i className="ri-mail-line text-accent-500 w-4 h-4 flex items-center justify-center"></i>
              <span>{contactItem.email}</span>
            </div>
            <div className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-700">
              <i className="ri-qq-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
              <span>QQ：{contactItem.qq}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}